import { useState } from 'react';
import LoadingView from './view/loading/LoadingView';
import LoginView from './view/login/LoginView';
import GamesView from './view/games/GamesView';
import RegisterView from './view/register/RegisterView';
import userClient from './infrastructure/userClient';
import User from './domain/User';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { useLoggedUserContext } from './AppContext';
import { useQuery } from "@tanstack/react-query";
import AdminView from './view/admin/AdminView';

function App() {
    const [initializing, setInitializing] = useState(true);
    const [loggedUser, setLoggedUser] = useLoggedUserContext();

    const loggedUserQuery = useQuery({
        queryKey: ["loggedUser"],
        queryFn: async () => await fetchLoggedUser(),
    })

    if (initializing && loggedUserQuery.isSuccess) {
        setInitializing(false);
        setTimeout(() => setLoggedUser(loggedUserQuery.data));
    }

    if (loggedUserQuery.isPending) {
        return <LoadingView/>;
    }
    else if (loggedUserQuery.isError) {
        return <div>ERROR</div>
    }
    else if (loggedUser && !loggedUser.admin) {
        return <BrowserRouter>
            <Routes>
                <Route path="/single" element={<GamesView show="single"/>}/>
                <Route path="/multi" element={<GamesView show="multi"/>}/>
                <Route path="/fame" element={<GamesView show="fame"/>}/>
                <Route path="*" element={<GamesView show="menu"/>}/>
            </Routes>
        </BrowserRouter>
    }
    else if (loggedUser && loggedUser.admin) {
        return <BrowserRouter>
            <Routes>
                <Route path="*" element={<AdminView/>}/>
            </Routes>
        </BrowserRouter>
    }
    else {
        return <BrowserRouter>
            <Routes>
                <Route path="/login" element={<LoginView/>}/>
                <Route path="*" element={<RegisterView/>}/>
            </Routes>
        </BrowserRouter>
    }
}

async function fetchLoggedUser() {
    const res = await userClient.getLoggedUser();

    if (res.ok) {
        return new User(await res.json());
    }
    else if (res.status === 401) {
        return null;
    }

    throw new Error("Can't get the logged user");
}

export default App;
